import { ParsingCommentsDataBundlePropType } from "@interfaces/data-type/type.pages-comments";
import { Dispatch,FoxIcon, StoragesSystem,  } from "index-module";
import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { HeaderGlobal } from "@module-layout/header/index.header.global";
import { FooterGlobal } from "@module-layout/footer/index.footer.global";
import { OwnImage } from "@img/module-images";
import { MyProject } from "./module/MyProject";


export interface ScreenHomePropTypeSmall {
  StoragesSystem: any,
  setStorage?: (obj: ParsingCommentsDataBundlePropType) => void
}

export type ScreenHomePropType = ScreenHomePropTypeSmall & RouteComponentProps;


const ScreenHomeDefaultProps : ScreenHomePropTypeSmall = {
  StoragesSystem: {
    catalog: [
    ]
  },
}

class ScreenHome extends Component<ScreenHomePropType,  any> {
  static defaultProps = ScreenHomeDefaultProps;
  constructor(props: any){
    super(props)
    this.state = {
      isFetching: false,
      apps: [],
      appsData: {},
    }
  }

  getcontact = () => {
    if(document.querySelector('#contact')){
      document.querySelector('#contact')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  render(){
    const { props, state } = this;
    return(
      <>
        <HeaderGlobal / >
          <section>
            <div className="onecol">
              <div className="backimg after2 slide25" style = {{backgroundImage: `url(${OwnImage.Back})`}}>
                <div className="ban absolute" style = {{minHeight: '37em', paddingTop: '80px'}}>
                  <div style = {{height: "80px"}}></div>
                  <div style = {{width: "100%", padding: "20px"}}>
                    <div className="onec-blue" style = {{backgroundColor: "rgba(255,255,255,0.2)", padding: '20px'}}>Who We Are Actually ?</div>
                    <div className="l2" style = {{fontSize: "2em", fontWeight: 400, paddingTop: "20px"}}>We Are Fullstack Apps Developer For Mobile Apps, Desktop Apps and Web Apps</div>
                  </div>
                  <div className="btnbox" style = {{paddingTop: "30px"}}>
                    <div className="onec-semiungu" style = {{paddingTop: "10px", paddingBottom: '10px'}} >Dont Be Hesitate To Contact Us Via Email Or Phone</div>
                    <a id="btn_contact" className="contactbtn" onClick={ this.getcontact} style = {{cursor: "pointer"}} >GET CONTACT</a>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="oneinfo onebg-blue onec-white" style = {{overflow: "hidden"}} >
              <label>Social Media App "PHOTOIN" Available</label> <a href="#" className="oneclick mar-side onehover">GET IT NOW</a>
            </div> */}

            <div className="onecol onebg-white">
              <div className="backimg" style = {{backgroundImage: `url(${OwnImage.BackTrans})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-semiblack">Who Are We ?</div>
                </div>
                <div className="onecol absolute fexbox" style = {{paddingBottom: "50px", overflow: "hidden", paddingTop: "20px", paddingLeft: "5%", paddingRight: "5%"}}>	
                  <div className="l2 chiledflex">
                    <img src={OwnImage.BackTrans} style = {{width: "100%", padding: '20px'}} />
                  </div>
                  <div className="l2 chiledflex">
                    <div style = {{fontWeight: "bold", fontSize: "1.2em"}}>Sort Story From Us</div>
                    <div className="onec-purple" style = {{padding: "20px 20px 17px 50px", fontSize: "1.1em", position: "relative"}}> 
                      {/* <label className="oneicon one-display" style = {{position: "absolute", left: 0, top: "20px", fontSize: "1.6em"}}></label>  */}
                      <FoxIcon icon = {"display"} className="oneicon" style = {{position: "absolute", left: 0, top: "20px", fontSize: "1.6em", width: '1.6em'}}  />
                      We professional software developer for mobile apps, desktop apps and website apps. 
                    </div>
                    <div className="onec-purple" style = {{padding: "20px 20px 17px 50px", fontSize: "1.1em", position: "relative"}}> 
                      {/* <label className="oneicon one-and" style = {{position: "absolute", left: 0, top: "20px", fontSize: "1.6em"}}></label>  */}
                      <FoxIcon icon = {"and"} className="oneicon" style = {{position: "absolute", left: 0, top: "20px", fontSize: "1.6em", width: '1.6em'}}  />

                      We have experience on industries over 4th years, with more than 10+ project that we have developt.
                    </div>
                    <div className="onec-purple" style = {{padding: "20px 20px 17px 50px", fontSize: "1.1em", position: "relative"}}> 
                      {/* <label className="oneicon one-location" style = {{position: "absolute", left: 0, top: "20px", fontSize: "1.6em"}}></label> */}
                      <FoxIcon icon = {"location"} className="oneicon" style = {{position: "absolute", left: 0, top: "20px", fontSize: "1.6em", width: '1.6em'}}  />
                      We are based in the heart of Yogyakarta city, and we are ready to handle your project anywhere.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- MORE ABOUT ME --> */}
            <div className="onecol ogray" style = {{textAlign: "center"}}  id="skills">
              <div className="m1 oneinfo absolute onebg-ungu" style = {{backgroundColor: "#8B07C4FF"}}>
                <div className="onetitle onec-blue">What We Can Build ?</div>
                <div className="talktome onec-white">We can developt anything for you, as what you want</div>
              </div>
              <div className="l1 absolute aboutme onebg-semiblack" style={{marginBottom: '-5px'}}>
                <div className="containerbox fexbox flex">
                  <div className="l4 oneleft box">
                    <img src={OwnImage.Dev1} />
                    <div className="tittle onec-semiungu">WEB APPS</div>
                    <div className="line onebg-semiungu"></div>
                    <div className="text">We can help you build any website based apps using the latest web technology available now, both open and the closed one. We are the master of PHP with all its frameworks, HTML, Python, CSS3, Javascript, Database Management and all other webby stuff.</div>
                  </div>
                  <div className="l4 oneleft box">
                    <img src={OwnImage.Dev2} />
                    <div className="tittle onec-green">DESKTOP APPS</div>
                    <div className="line onebg-green"></div>
                    <div className="text">We can help you build any desktop apps like Windows Apps, Mac Apps and Linux Apps using using the latest web and native C# technology. We create almost all desktop apps using web and Electron technologis </div>
                  </div>
                  <div className="l4 oneleft box">
                    <img src={OwnImage.Dev3} />
                    <div className="tittle onec-blue">MOBILE APPS</div>
                    <div className="line onebg-blue"></div>
                    <div className="text">We can help you build any popular Mobile Apps (iOS, Android) using the latest technology available right now. We gifted with the masters of Native Script, Android Studio, Java, React-Native and other related Mobile Apps Development Technologies</div>
                  </div>
                  <div className="l4 oneleft box ">
                    <img src={OwnImage.Dev4} />
                    <div className="tittle onec-semiorange">UI/UX and LOGO</div>
                    <div className="line onebg-semiorange"></div>
                    <div className="text">We fall in love greatly with aesthetics, so whether you’re going to build a brand, make a UI/UX improvements, or just creating simple graphical image for design, we will love it so much to give you a help.</div>
                  </div>
                </div>
                <div style={{backgroundColor: '#8B07C4FF', width: '100px', height: '100px', transform: 'rotateZ(45deg)',  OTransform: 'rotateZ(45deg)', msTransform: 'rotateZ(45deg)', WebkitTransform: 'rotateZ(45deg)', borderRadius: '10px', position: 'absolute', bottom: '-60px', left: '25%'}} />
                <div style={{backgroundColor: '#8B07C4FF', width: '100px', height: '100px', transform: 'rotateZ(45deg)',  OTransform: 'rotateZ(45deg)', msTransform: 'rotateZ(45deg)', WebkitTransform: 'rotateZ(45deg)', borderRadius: '10px', position: 'absolute', bottom: '-60px', left: '40%'}} />	
                <div style={{backgroundColor: '#8B07C4FF', width: '100px', height: '100px', transform: 'rotateZ(45deg)',  OTransform: 'rotateZ(45deg)', msTransform: 'rotateZ(45deg)', WebkitTransform: 'rotateZ(45deg)', borderRadius: '10px', position: 'absolute', bottom: '-60px', left: '75%'}} />	
              </div>	
            </div>
            {/* <!-- What WE LOVED --> */}
            <div className="onecol onebg-white">
              <div className="backimg" style={{backgroundImage: `url(${OwnImage.BackTrans})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">What We Will Give For You</div>
                  <div>We give you anything, our service is priority</div>
                </div>
                <div className="onecol absolute fexbox" style={{paddingBottom: '80px', overflow: 'hidden', paddingTop: '20px'}}>	
                  <div className="xl1 oneleft whatwe fexbox">
                    <div className="xl3 oneleft itemright" style={{minHeight: '100%'}}>
                      {/* <div className="oneicon one-gift img onec-purple" /> */}
                      <FoxIcon icon = {"gift"} className="oneicon one-gift img onec-purple"  />
                      <div className="oneright onec-blue headtext">GIVE YOU THE BEST SOLUTION</div>
                      <div className="oneright foottext">We will provide the best software solution for your company</div>
                    </div>
                    <div className="xl3 oneleft onehide-xl fexbox" style={{textAlign: 'center', maxHeight: '200px'}}>
                      <div className=" logo onec-darkungu chiledflex" style={{textAlign: 'center', width: '100%', padding: '100px', paddingTop: '70px'}}>
                        <img style={{width: '100%'}} src={OwnImage.Heart} />
                      </div>
                    </div>
                    <div className="xl3 oneleft itemleft" style={{minHeight: '100%'}}>
                      {/* <div className="oneicon one-wallet img onec-blue" /> */}
                      <FoxIcon icon = {"wallet"} className="oneicon one-gift img onec-blue"  />
                      <div className="oneleft onec-blue headtext">MOST CHEAP PRICE</div>
                      <div className="oneleft foottext">We provide a very complete service features at a very cheap price. We dare to compare with the service from other places</div>
                    </div>
                    <div className="xl3 oneleft itemright" style={{minHeight: '100%'}}>
                      {/* <div className="oneicon one-date img onec-orange" /> */}
                      <FoxIcon icon = {"date"} className="oneicon one-gift img onec-orange"  />
                      <div className="oneright onec-blue headtext">FASTER THAN THE DEADLINE</div>
                      <div className="oneright foottext">We finish every project you ordered long before the deadline</div>
                    </div>
                    <div className="xl3 oneleft itemleft onehide-xl" style={{minHeight: '100%'}}>
                    </div>
                    <div className="xl3 oneleft itemleft" style={{minHeight: '100%'}}>
                      {/* <div className="oneicon one-electron img onec-gray" /> */}
                      <FoxIcon icon = {"electron"} className="oneicon one-gift img onec-gray"  />
                      <div className="oneleft onec-blue headtext">GUARANTIED SERVICE</div>
                      <div className="oneleft foottext">We guarantee every result of the software we have created for you</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="onecol onebg-white">
              <div className="m1 oneinfo">
                <div className="onetitle onec-blue">Our Beloved Library And API</div>
                <div>This library And API was created for Web App, Desktop App and Mobile App</div>
              </div>
              <div className=" oneuser onecol fexbox">			
                <div className="item m4 oneleft ">
                  {/* <div className="icon oneicon one-php onec-orange" style={{fontSize: '5.3em', border: '7px solid', padding: '25px', borderRadius: '50%'}} /> */}
                  <FoxIcon icon = {"npm"} className="icon oneicon one-php onec-orange" style={{fontSize: '5.3em', border: '7px solid', padding: '25px', borderRadius: '50%'}}  />
                  <div className="tittle">lazyfox-circular-countdown</div>
                  <div className="text">React Native Library</div>
                </div>
                <div className="item m4 oneleft item ">
                  {/* <div className="icon oneicon one-js onec-green" style={{fontSize: '5.3em', border: '7px solid', padding: '25px', borderRadius: '50%'}} /> */}
                  <FoxIcon icon = {"npm"} className="icon oneicon one-php onec-green" style={{fontSize: '5.3em', border: '7px solid', padding: '25px', borderRadius: '50%'}}  />

                  <div className="tittle">rn-modal-window</div>
                  <div className="text">React Native Library</div>
                </div>
                <div className="item m4 oneleft item ">
                  {/* <div className="icon oneicon one-php onec-blue" style={{fontSize: '5.3em', border: '7px solid', padding: '25px', borderRadius: '50%'}} /> */}
                  <FoxIcon icon = {"electron"} className="icon oneicon one-php onec-blue" style={{fontSize: '5.3em', border: '7px solid', padding: '25px', borderRadius: '50%'}}  />

                  <div className="tittle">lazyfox-map-direction</div>
                  <div className="text">ReactJS & React Native Library</div>
                </div>
                <div className="item m4 oneleft item">
                  <div className="icon oneicon one-circle-right" />
                  <div className="text"><a href="https://www.npmjs.com/~ridwan_foxdream" target="_blank" className="oneclick-orange mar-side onehover">GET MORE INFO</a></div>
                </div>
              </div>
            </div>



            <div className="onecol onebg-semiblack" id="portofolio">
              <div className="backimg after onecontainer" style ={{backgroundImage: `url(${OwnImage.Back8})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">All Our Portofolio We Have</div>
                  <div>Almost All Apps, We Created Using Web Technology And Java</div>
                </div>
                <div className="onecol apps absolute fexbox" id="apps_client">
                  <MyProject /> 
                </div>
                <div className="onecontainer btnmore absolute">
                  <label>Get More Apps</label><a className="oneclick-orange  mar-side onehover" href="/ridwan/store/">VIEW ALL</a> 
                </div>
              </div>
            </div>
          </section>
        <FooterGlobal {...props}  />
      </>
    )
  }
}

const mapStateToProps = (state: any) => ({
  StoragesSystem: state.StoragesSystem,
})
const mapDispatchToProps = (dispatch: Dispatch ) => ({
  setStorage: ({ data, type }: ParsingCommentsDataBundlePropType) => dispatch( new StoragesSystem().setStorage({ data, type }) ),
})

export default withRouter(connect( mapStateToProps, mapDispatchToProps )( ScreenHome ));
